import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Tabs from "@/components/Tabs/index.vue";
import { getCombatNewsPagedList } from "@/data";
import PagedList from "@/components/PagedList.vue";
import type { NewsPageList } from "@/data/index.type";
import TabPanel from "../components/Tabs/TabPanel.vue";
import LicenseToken from "@/components/LicenseToken.vue";
import Banner from "@/components/Banner.vue";
import avatar from "../assets/contact-male-avatar.png";
import FloatingContact from "../components/FloatingContact.vue";
import { ref } from "vue";
import { useStore } from "@/store";
import { useStatistic } from "@/tools";

export default /*#__PURE__*/_defineComponent({
  __name: 'Combat',
  setup(__props) {

const store = useStore();
const data = ref<NewsPageList>([]);
const total = ref<number>(0);
const pageSize = ref(10);

useStatistic();
const refresh = (pageIndex: number) => {
  getCombatNewsPagedList(pageIndex).then((res) => {
    data.value = res.data.data.lists;
    if (total.value !== res.data.data.total) {
      total.value = res.data.data.total;
    }
    if (pageSize.value !== res.data.data.pagesize) {
      pageSize.value = res.data.data.pagesize;
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Banner, {
      src: "https://www.szjfjt.com/images/fbz.jpg",
      href: "https://www.fbz.com/",
      style: {"min-height":"80px"},
      show: ""
    }),
    _createVNode(Tabs, null, {
      default: _withCtx(() => [
        _createVNode(TabPanel, {
          title: "违法侵权打击",
          subtitle: "共同维护正版游戏，创造更好的游戏环境"
        }, {
          default: _withCtx(() => [
            _createVNode(PagedList, {
              data: data.value,
              refresh: refresh,
              total: total.value,
              "page-size": pageSize.value
            }, null, 8, ["data", "total", "page-size"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(LicenseToken),
    (_unref(store).state.contacts)
      ? (_openBlock(), _createBlock(FloatingContact, {
          key: 0,
          title: "在线咨询",
          qq: _unref(store).state.contacts[3],
          avatar: _unref(avatar)
        }, null, 8, ["qq", "avatar"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})